import { render } from "./SolicitudesAceptadas.vue?vue&type=template&id=5845920c&scoped=true"
import script from "./SolicitudesAceptadas.vue?vue&type=script&lang=js"
export * from "./SolicitudesAceptadas.vue?vue&type=script&lang=js"

import "./SolicitudesAceptadas.vue?vue&type=style&index=0&id=5845920c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845920c"]])

export default __exports__